import { IYouMayAlsoLikeItem } from '../../shopping-cart/cart-bridger-pay/interfaces';
import Imgix from 'react-imgix';
import YouMayAlsoLikeItemPrices from './you-may-also-like-item-prices';
import React from 'react';
import StarRating from '../../../ui/rating/star-rating';
import { getIsChina } from '../../../domain/hidden-data-provider';
import CartIcon2 from '../../../ui/svg/shopping-cart/cart-2';
import { sendGAEvent, sendGAEventAddToCart } from '../../../domain/marketing/gtm-provider';
import { addToCartPopupGaAction } from './add-to-cart-popup';

interface IYouMayAlsoLikeItemProps {
    item: IYouMayAlsoLikeItem;
    addProductHandler: (productId: number) => void;
}

const YouMayAlsoLikeItem = ({ item, addProductHandler }: IYouMayAlsoLikeItemProps) => {

    const isRatingVisible = item?.rating > 0 && !getIsChina();

    const changeItem = () => {
        sendGAEvent(
            addToCartPopupGaAction,
            `Add to Cart: ${ item.documentName }`
        );

        console.log('item', item)

        addProductHandler(item.skuid);

        sendGAEventAddToCart(
            item.documentName,
            item.skuNumber,
            item.skuPrice,
            item.documentUrlPath,
            addToCartPopupGaAction,
        );
    };

    return (
        <div
            className="w-add-to-cart-popup-like-item grid md:grid-cols-1 md:grid-rows-subgrid md:row-span-5 mb-4 md:mb-0 gap-x-4 gap-y-2 md:gap-0">
            <a
                href={ item.documentUrlPath }
                title={ item.documentName }
                onClick={ () => {
                    sendGAEvent(
                        addToCartPopupGaAction,
                        `Recommended Image: ${ item.documentName }`
                    );
                }}
                className="flex md:block items-center md:items-start bg-gray-100 rounded overflow-hidden mb-4 row-start-1 row-end-4 md:row-auto px-2">
                <Imgix
                    src={item.thumb}
                    height={165}
                    htmlAttributes={{
                        alt: `Image for ${ item.documentName }`,
                        loading: 'lazy',
                    }}
                    disableQualityByDPR
                />
            </a>

            <a
                href={item.documentUrlPath}
                onClick={ () => {
                    sendGAEvent(
                        addToCartPopupGaAction,
                        `Recommended Name: ${ item.documentName }`
                    );
                }}
                className="text-sm no-underline text-gray-700 font-bold">{ item.documentName }</a>

            <YouMayAlsoLikeItemPrices item={item}/>

            <div data-grid-stars="true" className="col-start-2 col-end-2 md:col-auto">
                {
                    isRatingVisible &&
                    <div className="mb-4">
                        <StarRating
                            rating={item.rating}
                            reviews={item.reviewsTotal}
                            url={item.documentUrlPath}
                            gaEventName={ addToCartPopupGaAction }
                            gaEventValue={ `Stars: ${ item.documentName} ` }
                        />
                    </div>
                }
            </div>

            <button
                onClick={changeItem}
                type="button"
                className="w-btn w-auto w-btn-outline-black px-8 row-start-1 row-end-4 md:row-auto col-start-3 col-end-3 md:col-auto hidden md:block">
                Add to Cart
            </button>

            <button
                onClick={changeItem}
                type="button"
                className="md:hidden row-start-1 row-end-4 md:row-auto col-start-3 col-end-3 md:col-auto flex justify-center items-center">
                <CartIcon2 width={ '36px' } height={ '30px' } color={ '#3452FF' } />
            </button>
        </div>
    )
};

export default YouMayAlsoLikeItem;